import { Button, Grid } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { IAdditionalDocument } from "../../models/income.model";
import { RootState } from "../../redux/store";
import './downloadFile.css';
import { requestPermission } from "../../utility/requestPermission";


export default function DownloadFile({ additionalDocuments }: { additionalDocuments: IAdditionalDocument, referenceKey: string }) {
    const mode = useSelector((state: RootState) => state.theme)

    const downloadFile = (url: string) => {
        // requestPermission(['notification']);
        if (url) {
            const link = document.createElement('a');
            link.target = '_blank';
            link.href = url;
            link.download = url;
            link.click();
        }
    }

    return (
        <Grid container>
            {additionalDocuments?.additionalDocumentTerms !== undefined && additionalDocuments?.additionalDocumentTerms !== null
                && additionalDocuments?.additionalDocumentTerms !== "" ?
                <Grid item
                    xs={12}
                    style={{
                        padding: '0px',
                        marginBottom: '1rem',
                    }}>
                    <span style={{ fontSize: '13px' }}>
                        <span className="additionalDocumentItems" dangerouslySetInnerHTML={{ __html: additionalDocuments.additionalDocumentTerms }} />
                    </span>
                </Grid> : null
            }
            {additionalDocuments?.additionalDocumentItems?.map((item, index) => (
                <React.Fragment key={index}>
                    <Grid item
                        xs={12}
                        style={{
                            padding: '0px',
                            marginBottom: '1rem',
                        }}>
                        <span style={{ fontSize: '11px' }}>
                            <span className="additionalDocumentItems" dangerouslySetInnerHTML={{ __html: item.description }} />
                        </span>
                    </Grid>
                    <Grid item
                        xs={12}
                        style={{
                            padding: '0px',
                            marginBottom: '1rem',
                        }}>
                        <Button style={{
                            backgroundColor: 'var(--input-bg-color)',
                            border: mode === 'light' ? '1px solid #BBA57A' : "none",
                            width: '100%',
                            fontSize: '15px',
                            fontWeight: 'bold',
                            height: '42px'
                        }}
                            onClick={() => downloadFile(item.downloadUrl)}
                        >
                            <img src="/images/fileDownload.svg" alt="download" />
                            <span className="text-[#BBA57A]" style={{ marginRight: '3px' }}>{item.title}</span>
                        </Button>
                    </Grid>
                </React.Fragment>
            ))}
        </Grid>


    );
}
